
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/manage-groups/jst/groupCategories';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class='ic-Action-header'>\n    <div class='ic-Action-header__Primary'>\n      <h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.headings.course_groups", "Student Groups", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.headings.course_groups", "Student Groups", options)))
    + "</h2>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.can_add_groups), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n    <p>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.course_group_explanation", "Student groups are a useful way to organize students for things like group projects or papers. Every student group gets their own calendar, discussion board and collaboration tools so they can organize themselves and work together more effectively.", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.course_group_explanation", "Student groups are a useful way to organize students for things like group projects or papers. Every student group gets their own calendar, discussion board and collaboration tools so they can organize themselves and work together more effectively.", options)))
    + "\n    </p>\n\n    <p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.group_assignment_instructions", "You can randomly assign students to groups of a specific size, or manually create and organize the groups. Once your groups are created, you can set assignments to be \"group submission\" assignments, which means each group will have one submission for all users of that group.", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.group_assignment_instructions", "You can randomly assign students to groups of a specific size, or manually create and organize the groups. Once your groups are created, you can set assignments to be \"group submission\" assignments, which means each group will have one submission for all users of that group.", options)))
    + "\n    </p>\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.horizon_course), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <div class='ic-Action-header__Secondary'>\n          <button id='add-group-set' class='btn btn-primary' title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "add_group_set_f9809e11", "Add Group Set", options) : helperMissing.call(depth0, "t", "add_group_set_f9809e11", "Add Group Set", options)))
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "add_group_set_f9809e11", "Add Group Set", options) : helperMissing.call(depth0, "t", "add_group_set_f9809e11", "Add Group Set", options)))
    + "\"><i class='icon-plus'></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.group_set", "Group Set", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.group_set", "Group Set", options)))
    + "</button>\n        </div>\n      ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class='ic-Action-header'>\n    <div class='ic-Action-header__Primary'>\n      <h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.headings.account_groups", "Account-level Student Groups", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.headings.account_groups", "Account-level Student Groups", options)))
    + "</h2>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.can_add_groups), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n    <p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.account_group_explanation", "Account-level student groups are a good way to group students without being tied to a specific course. Every student group gets their own calendar, discussion board and collaboration tools so they can organize themselves and work together more effectively.", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.account_group_explanation", "Account-level student groups are a good way to group students without being tied to a specific course. Every student group gets their own calendar, discussion board and collaboration tools so they can organize themselves and work together more effectively.", options)))
    + "\n    </p>\n  ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <li class=\"static\"><a href=\"/courses/";
  if (helper = helpers.context_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.context_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "/users\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.tabs.everyone", "Everyone", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.tabs.everyone", "Everyone", options)))
    + "</a></li>\n    ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.horizon_course), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class='pull-right group-categories-actions'>\n      <button id='add-group-set' class='btn btn-primary' title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "add_group_set_f9809e11", "Add Group Set", options) : helperMissing.call(depth0, "t", "add_group_set_f9809e11", "Add Group Set", options)))
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "add_group_set_f9809e11", "Add Group Set", options) : helperMissing.call(depth0, "t", "add_group_set_f9809e11", "Add Group Set", options)))
    + "\"><i class='icon-plus'></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.group_set", "Group Set", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.group_set", "Group Set", options)))
    + "</button>\n    </div>\n    ";
  return buffer;
  }

  buffer += "<h1 class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_categories")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_categories.headings.groups", "Groups", options) : helperMissing.call(depth0, "t", "groups.manage.group_categories.headings.groups", "Groups", options)))
    + "</h1>\n<div class='empty-groupset-instructions'>\n  ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(5, program5, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n<div id=\"create-group-set-modal-mountpoint\"></div>\n  <div style=\"display:none\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isCourse), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n<div id=\"group_categories_tabs\" class=\"ui-tabs-minimal\">\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.can_add_groups), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <ul class='collectionViewItems'>\n  </ul>\n  <!--panels get inserted dynamically-->\n</div>\n\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '1d',
      bundle: 'jst/groups/manage/groupCategories'
    });
  ;
    export default templates[name];
  